import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { API } from "../App";

let cache = {};
let fetchedForToken = null;
const listeners = new Set();
const notify = () => listeners.forEach((l) => l({ ...cache }));

export const useParticipations = (token) => {
  const [map, setMap] = useState(cache);

  useEffect(() => {
    listeners.add(setMap);
    return () => listeners.delete(setMap);
  }, []);

  useEffect(() => {
    if (!token) {
      if (fetchedForToken !== null) {
        cache = {};
        fetchedForToken = null;
        notify();
      }
      return;
    }
    if (fetchedForToken === token) return;
    fetchedForToken = token;
    axios
      .get(`${API}/my/participations`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => {
        cache = r.data.participations || {};
        notify();
      })
      .catch(() => {});
  }, [token]);

  const markParticipation = useCallback((productId, type) => {
    cache = { ...cache, [productId]: type };
    notify();
  }, []);

  return { participations: map, markParticipation };
};

export const participationLabel = (p) =>
  p?.type === "bid" ? "Participas" : "Solicitado";
